import { getAllZones } from './getAllZones'

export const zones = [getAllZones]
